module.exports = __webpack_public_path__ + "static/media/addUserSingle.20d7d036.svg";